var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.prizes.length > 0)?_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"font-weight-bold",domProps:{"textContent":_vm._s(_vm.prizes.join(' + '))}}),_c('div',{staticClass:"text-muted text-small",domProps:{"textContent":_vm._s(_vm.strategy)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }